module.exports = __webpack_public_path__ + "fonts/Rubik-Medium.11f22f21.ttf";